var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhoneIcon = function SvgPhoneIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 22,
    viewBox: "0 0 14 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M13 4H1V2a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1zM1 17h12V5H1zm12 3a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1v-2h12zM12 0H2a2 2 0 0 0-2 2v18a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2M8 2H6a.5.5 0 1 0 0 1h2a.5.5 0 1 0 0-1M7 20.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
  })));
};
export default SvgPhoneIcon;